import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, ShieldCheck } from "lucide-react";
import { API } from "../lib/api";

export default function PublicConsent() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/consent/${token}`).then((r) => { setD(r.data); if (r.data.status !== "SENT") setDone(r.data.status); })
      .catch((e) => setErr(e.response?.data?.detail || "This link is not valid."));
  }, [token]);
  const reply = async (agree) => {
    setBusy(true);
    try { setDone((await axios.post(`${API}/public/consent/${token}`, { agree })).data.status); } catch (e) { setErr(e.response?.data?.detail || "Could not save your reply."); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen bg-[#0B1017] text-slate-100 flex items-start justify-center p-5" data-testid="consent-page">
      <div className="w-full max-w-lg c-surface p-6 mt-6 grid gap-4">
        <div className="flex items-center gap-2 text-[#00E599] text-sm font-semibold"><ShieldCheck size={18} />Aadhaar consent</div>
        {err && <p className="text-rose-400 text-sm" data-testid="consent-error">{err}</p>}
        {d && <>
          <h1 className="text-xl font-bold">{d.worker_name}</h1>
          {d.local?.length > 0 && <div className="grid gap-2 text-base leading-relaxed" data-testid="consent-local">
            <span className="text-[11px] tracking-widest text-slate-500">{d.language?.toUpperCase()}</span>{d.local.map((t) => <p key={t}>{t}</p>)}</div>}
          <div className={`grid gap-2 leading-relaxed ${d.local?.length ? "text-sm text-slate-400 border-t border-[#1F2A3E] pt-3" : "text-base"}`} data-testid="consent-english">
            {d.local?.length > 0 && <span className="text-[11px] tracking-widest text-slate-500">ENGLISH</span>}{d.english.map((t) => <p key={t}>{t}</p>)}</div>
          {done === "AGREED" && <p className="flex items-center gap-2 text-emerald-400" data-testid="consent-done-agreed"><CheckCircle2 size={18} />Thank you. You agreed. You will get a code from UIDAI on your Aadhaar mobile.</p>}
          {done === "DECLINED" && <p className="flex items-center gap-2 text-rose-300" data-testid="consent-done-declined"><XCircle size={18} />You said no. Your details will not be checked with UIDAI.</p>}
          {!done && <div className="grid grid-cols-2 gap-3 pt-2">
            <button disabled={busy} onClick={() => reply(true)} className="rounded-lg bg-[#00E599] text-[#0B1017] font-semibold py-3 text-base disabled:opacity-50" data-testid="consent-agree-btn">{d.buttons?.[0] || "I agree"}</button>
            <button disabled={busy} onClick={() => reply(false)} className="rounded-lg border border-[#1F2A3E] py-3 text-base disabled:opacity-50" data-testid="consent-decline-btn">{d.buttons?.[1] || "No"}</button>
          </div>}
        </>}
        {!d && !err && <p className="text-sm text-slate-500">Loading…</p>}
      </div>
    </div>);
}
